import { IBrandRatingsProductTilesXP } from "@faire/web-api/indigofair/seo/IBrandRatingsProductTilesXP";
import { PRODUCT_TILE_BRAND_RATINGS_240826 } from "@faire/web-api/indigofair/settings/PRODUCT_TILE_BRAND_RATINGS_240826";

import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingProductTileBrandRatings =
  (): IBrandRatingsProductTilesXP =>
    useSetting(
      PRODUCT_TILE_BRAND_RATINGS_240826,
      IBrandRatingsProductTilesXP.Bucket.BUCKET_UNKNOWN
    );

export const useAssignSettingProductTileBrandRatings = () =>
  useAssignSetting(PRODUCT_TILE_BRAND_RATINGS_240826);
